"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PureSuperToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "initialSupply",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialAddress",
                type: "address",
            },
        ],
        name: "initializeProxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PureSuperToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PureSuperToken__factory = PureSuperToken__factory;
PureSuperToken__factory.bytecode = _bytecode;
PureSuperToken__factory.abi = _abi;
//# sourceMappingURL=PureSuperToken__factory.js.map